export default "__VITE_ASSET__af51bce1__"